import {ReactComponent as Icon1} from '../../../Assets/Icons/icon1.svg';
import {ReactComponent as Icon2} from '../../../Assets/Icons/icon2.svg';
import {ReactComponent as Icon3} from '../../../Assets/Icons/icon3.svg';
import {ReactComponent as Icon4} from '../../../Assets/Icons/icon3.svg';

import {ReactComponent as Users} from '../../../Assets/Icons/users.svg';
import {ReactComponent as Projects} from '../../../Assets/Icons/projects.svg';
import {ReactComponent as Screens} from '../../../Assets/Icons/screens.svg';
import {ReactComponent as Sketch} from '../../../Assets/Icons/sketch.svg';
import {ReactComponent as Activity} from '../../../Assets/Icons/activity.svg';
import {ReactComponent as Usability} from '../../../Assets/Icons/usability.svg';

import logo1 from '../../../Assets/Icons/buzzfeed.svg';
import logo2 from '../../../Assets/Icons/stripe.svg';
import logo3 from '../../../Assets/Icons/godaddy.svg';
import logo4 from '../../../Assets/Icons/bnsf.svg';
import logo5 from '../../../Assets/Icons/udemy.svg';
import logo6 from '../../../Assets/Icons/allianz.svg';
import logo7 from '../../../Assets/Icons/visa.svg';




export const images=[
    logo1,logo3,logo4,logo5,logo6,logo7,
    logo1,logo3,logo4,logo5,logo6,logo7,
    logo1,logo3,logo4,logo5,logo6,logo7,
]
export const features= [
    {
        icon:<Users/>,
        title:"Unilimited Users",
        desc:"New subscription plans offer up to 50 seats at no pain secures and ensures the reliability."
    },
    {
        icon:<Projects />,
        title:"Unlimited Projects",
        desc:"New subscription plans offer up to 50 seats at no pain painsecures and ensures the reliability."
    },
    {
        icon:<Screens />,
        title:"Unlimited Screens",
        desc:"New subscription plans offer up to 50 seats at no awes secures and ensures the reliability."
    },
    {
        icon:<Sketch />,
        title:"Sketch Plugin",
        desc:"New subscription plans offer up to 50 seats at no awes secures and ensures the reliability."

    },
    {
        icon:<Activity />,
        title:"Project Activity",
        desc:"New subscription plans offer up to 50 seats at no awes secures and ensures the reliability."

    },
    {
        icon:<Usability />,
        title:"Usability Testing",
        desc:"New subscription plans offer up to 50 seats at no awes secures and ensures the reliability."
        
    }
]
export const services =[
    {

        icon:<Icon1 />,
        title:"Collaboration",
        desc:"Clients and colleagues can add comments directly on designs.",

    },
    {
        icon:<Icon2 />,
        title:"Wireframing",
        desc:"Create and share simple wireframes of websites and mobile apps.",
    
    },
    {
        icon:<Icon3 />,
        title:"Prototyping",
        desc:"Transform your design and wireframes into clickable, interactive prototypes.",
    
    },
    {
        icon:<Icon4 />,
        title:"Usability Testing",
        desc:"Analyze how users interact with your interfaces.",
       
    }
];


